import styled from 'styled-components/macro'

export const RangeLabel = styled.label`
  margin-right: 139px;
`
